// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__niNRU","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__JVmYT"};